// removed by extract-text-webpack-plugin
module.exports = {"miniChart":"antd-pro-charts-miniChart","chartContent":"antd-pro-charts-chartContent","chartLoading":"antd-pro-charts-chartLoading"};


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/src/components/Charts/index.less
// module id = 162
// module chunks = 0